import { store } from '@core/Store'
import {
  setOutcomeIdsInBetslip,
  updateBetslipMaximized,
  updateUserData,
} from '@core/Areas/KambiClient/Store'

export const handleClientSubscriptions = (response: WapiSubscriptionEvents): void => {
  switch (response.type) {
    case 'BetslipMaximizedChange': {
      const isMaximized = response.data?.maximized
      if (isMaximized === undefined) return
      store.dispatch(updateBetslipMaximized(isMaximized))
      break
    }

    case 'UserData': {
      const { sessionId } = response.data || {}
      if (sessionId === undefined) return
      store.dispatch(updateUserData(sessionId))
      break
    }

    case 'BetslipOutcomes': {
      const outcomes = response.data?.outcomes
      if (Array.isArray(outcomes)) {
        store.dispatch(setOutcomeIdsInBetslip(outcomes.map(({ id }) => id)))
      }
      break
    }
  }
}
